var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import { Checkbox, FormControlLabel } from '@material-ui/core';
import { DragIndicator, RemoveCircleOutlineOutlined } from '@material-ui/icons';
import ConfigFieldControl from './components/ConfigFieldControl';
import { ConfigAccordion, ConfigAccordionSummary, ConfigAccordionDetails } from './components/ConfigAccordion';
import FormConfigEventTransitionList from './FormConfigEventTransitionList';
import ConfigContent from './components/ConfigContent';
import ConfigInput from './components/ConfigInput';
import styled from 'styled-components';
import { useFormContext } from '../FormContext';
const StyledDragIndicator = styled.div `
  display: flex;
  align-items: center;
`;
export const FormConfigEvent = forwardRef((_a, ref) => {
    var { event, expanded, dragHandleProps, onChange, onDelete, onExpand } = _a, props = __rest(_a, ["event", "expanded", "dragHandleProps", "onChange", "onDelete", "onExpand"]);
    const { additionalEventConfigurations } = useFormContext();
    return (React.createElement(ConfigAccordion, Object.assign({ square: true, ref: ref }, props, { expanded: Boolean(expanded), onChange: (_, isExpanded) => onExpand === null || onExpand === void 0 ? void 0 : onExpand(event, isExpanded), onClick: () => onExpand === null || onExpand === void 0 ? void 0 : onExpand(event, true) }),
        React.createElement(ConfigAccordionSummary, { expandIcon: React.createElement(RemoveCircleOutlineOutlined, null), IconButtonProps: {
                size: 'small',
                onClick: e => {
                    e.stopPropagation();
                    onDelete === null || onDelete === void 0 ? void 0 : onDelete(event);
                }
            } },
            React.createElement(StyledDragIndicator, Object.assign({ className: 'drag-indicator' }, dragHandleProps),
                React.createElement(DragIndicator, null)),
            React.createElement(ConfigInput, { fullWidth: true, className: 'event-name', placeholder: 'Event Name', 
                // size='small'
                value: event.name || '', onChange: event => onChange === null || onChange === void 0 ? void 0 : onChange({ name: event.target.value }) })),
        React.createElement(ConfigAccordionDetails, null,
            React.createElement(ConfigContent, null,
                React.createElement(ConfigFieldControl, null,
                    React.createElement(ConfigInput, { fullWidth: true, multiline: true, className: 'event-description', variant: 'outlined', placeholder: 'Event Description', 
                        // label='Event Description'
                        // size='small'
                        value: event.description || '', onChange: event => onChange === null || onChange === void 0 ? void 0 : onChange({ description: event.target.value }) })),
                React.createElement(FormControlLabel, { label: 'Auto transition (transient)', control: React.createElement(Checkbox, { color: 'primary', checked: Boolean(event.isTransient), onChange: () => onChange === null || onChange === void 0 ? void 0 : onChange({ isTransient: !event.isTransient }) }) }), additionalEventConfigurations === null || additionalEventConfigurations === void 0 ? void 0 :
                additionalEventConfigurations.map((AdditionalConfiguration, index) => (React.createElement(AdditionalConfiguration, { key: index, event: event, onChange: onChange })))),
            React.createElement(FormConfigEventTransitionList, { event: event }))));
});
export default FormConfigEvent;
//# sourceMappingURL=FormConfigEvent.js.map